import React, { useState, useEffect } from "react";
import commonDatas  from '../../apps/CommonDatas'

import './List.css';

import { Link } from "react-router-dom";

const videoIdList = {
	'model1_1': ["https://player.vimeo.com/video/1002781140?h=120a323a38&badge=0&autopause=0&player_id=0&app_id=58479", "https://player.vimeo.com/video/1002783108?h=b5a2e2d55b&badge=0&autopause=0&player_id=0&app_id=58479"],
	'model1_2': ["https://player.vimeo.com/video/1002775994?h=8f1e1e8862&badge=0&autopause=0&player_id=0&app_id=58479"],
	'model1_3': ["https://player.vimeo.com/video/1002747059?h=c2dec99ab7&badge=0&autopause=0&player_id=0&app_id=58479"],
	'model1_4': ["https://player.vimeo.com/video/1002760180?h=9805ed4ce9&badge=0&autopause=0&player_id=0&app_id=58479"],
	'model2_1': ["https://player.vimeo.com/video/1002781140?h=120a323a38&badge=0&autopause=0&player_id=0&app_id=58479", "https://player.vimeo.com/video/1002785325?h=b6386b8625&badge=0&autopause=0&player_id=0&app_id=58479"],
	'model2_2': ["https://player.vimeo.com/video/1002779009?h=1c9ba1820f&badge=0&autopause=0&player_id=0&app_id=58479"],
	'model2_3': ["https://player.vimeo.com/video/1002766717?h=361c0012e8&badge=0&autopause=0&player_id=0&app_id=58479"],
	'model2_4': ["https://player.vimeo.com/video/1002768838?h=69ee514754&badge=0&autopause=0&player_id=0&app_id=58479"],
	'model2_5': ["https://player.vimeo.com/video/1002763513?h=cee41ef5d3&badge=0&autopause=0&player_id=0&app_id=58479"],
	'model2_6': ["https://player.vimeo.com/video/1002770622?h=264408b259&badge=0&autopause=0&player_id=0&app_id=58479"],
	'model3_1': ["https://player.vimeo.com/video/1002755108?h=b580ce539a&badge=0&autopause=0&player_id=0&app_id=58479"],
	'model3_2': ["https://player.vimeo.com/video/1002758117?h=958c8e6d61&badge=0&autopause=0&player_id=0&app_id=58479"],
	'model3_3': ["https://player.vimeo.com/video/1002773576?h=a591dbc7f1&badge=0&autopause=0&player_id=0&app_id=58479"]
}
export function List () {
  const foundModelList = commonDatas.loadFoundList();
  var matchCount = 0;

  for( var j = 0;j < commonDatas.objCountList.length;j++ ){
    for( var i = 0;i < commonDatas.objCountList[j];i++ ){
      if( foundModelList[j][i] ){
        matchCount = matchCount + 1;
      }
    }
  }

  let baseTabId = 1;
  let basePopupId = "";
  let baseVideoId = 0;
  var foundModelId = commonDatas.getCookie("last_found_model");
  var foundModelType = commonDatas.getCookie("last_found_model_type");
  
  if((foundModelId !== undefined) && (foundModelId != null) && (foundModelId.length >= 3)){
	var modelId = foundModelId.split("_");
	if( modelId.length >= 2 ){
      var gid = parseInt(modelId[0]);
      var oid = parseInt(modelId[1]);

      if((gid > 0) && (oid > 0)){
        if( foundModelList[gid - 1][oid - 1] ){
          basePopupId = "model" + foundModelId;
          
          baseVideoId = Math.floor(Math.random() * videoIdList[basePopupId].length);
          baseTabId = parseInt(foundModelType);

          commonDatas.setCookie("last_found_model", 0);
        }
      }
 	}
  }
  const [tabId, setTabId] = useState(baseTabId);
  const [popupId, setPopupId] = useState(basePopupId);
  const [videoId, setVideoId] = useState(baseVideoId);
  
  const changeTab = (id) => {
	  setTabId(id);
  }
  const onTab1Click = (e) => {
	e.preventDefault();
	
	changeTab(1);
  } 
  const onTab2Click = (e) => {
	e.preventDefault();

	changeTab(2);	
  } 
  const onPopupCloseClick = (e) => {
	e.preventDefault();
	
	setPopupId("");
	setVideoId(0);
  }
  const onLinkClick = (e, id) => {
/*
    var modelId = id.substr(5).split("_");
    var gid = parseInt(modelId[0]) - 1;
    var oid = parseInt(modelId[1]) - 1;

    if( foundModelList[gid][oid] ){
      e.preventDefault();
      setPopupId(id);
    }
*/
  }
  useEffect(() => {
    document.getElementsByTagName("html")[0].scrollTop = 0;
	document.body.scrollTop = 0;
  }, []);
  return (
    <>
      <div id="list" className={tabId === 1 ? "content_wrapper tab1" : "content_wrapper tab2"}>
        <div className="position_relative list_header_title">
          <h1><a href="./"><img src="./images/list_header.jpg" alt="恐竜バトルを楽しもう！" width="100%" /></a></h1>
        </div>
        <div className="content_inner">
          <div className="list_header">
            <div className="pt50 mb70"><img src="./images/list_label.png" width="89.333%" alt="えらんでね" /></div>
          </div>
          <div className="list_tab_wrapper">
            <a id="list_tab1" className={tabId === 1 ? "list_tab active" : "list_tab disable"} href="/#" onClick={(e) => onTab1Click(e)}><img src={tabId === 1 ? "./images/list_tab1_active.png" : "./images/list_tab1.png"} width="100%" alt="りょうほう" /></a>
            <a id="list_tab2" className={tabId === 2 ? "list_tab active" : "list_tab disable"} href="/#" onClick={(e) => onTab2Click(e)}><img src={tabId === 2 ? "./images/list_tab2_active.png" : "./images/list_tab2.png"} width="100%" alt="うすしお味" /></a>
          </div>
          <div className="list_wrapper">
	        <div className="list_block tab1_model_list pt35">
	          <div className="list_block_inner">
		        <Link id="model1_1" className="model_link" to="/camera" state={{model: "1_1", type: "1"}} onClick={(e) => onLinkClick(e, "model1_1")}><img className="model" src={foundModelList[0][0] ? "./images/list_model1_1_on.png" : "./images/list_model1_1.png"} alt="ピカチュウ" /></Link>
		        <Link id="model1_2" className="model_link" to="/camera" state={{model: "1_2", type: "1"}} onClick={(e) => onLinkClick(e, "model1_2")}><img className="model" src={foundModelList[0][1] ? "./images/list_model1_2_on.png" : "./images/list_model1_2.png"} alt="ピカチュウ" /></Link>
		        <Link id="model3_1_1" className="model_link" to="/camera" state={{model: "3_1", type: "1"}} onClick={(e) => onLinkClick(e, "model3_1")}><img className="model" src={foundModelList[2][0] ? "./images/list_model3_1_on.png" : "./images/list_model3_1.png"} alt="ピチュー" /></Link>
		        <Link id="model1_3" className="model_link" to="/camera" state={{model: "1_3", type: "1"}} onClick={(e) => onLinkClick(e, "model1_3")}><img className="model" src={foundModelList[0][2] ? "./images/list_model1_3_on.png" : "./images/list_model1_3.png"} alt="プリン" /></Link>
		        <Link id="model1_4" className="model_link" to="/camera" state={{model: "1_4", type: "1"}} onClick={(e) => onLinkClick(e, "model1_4")}><img className="model" src={foundModelList[0][3] ? "./images/list_model1_4_on.png" : "./images/list_model1_4.png"} alt="ゲンガー" /></Link>
		        <Link id="model3_2_1" className="model_link" to="/camera" state={{model: "3_2", type: "1"}} onClick={(e) => onLinkClick(e, "model3_2")}><img className="model" src={foundModelList[2][1] ? "./images/list_model3_2_on.png" : "./images/list_model3_2.png"} alt="メタモン" /></Link>
		        <Link id="model3_3_1" className="model_link" to="/camera" state={{model: "3_3", type: "1"}} onClick={(e) => onLinkClick(e, "model3_3")}><img className="model" src={foundModelList[2][2] ? "./images/list_model3_3_on.png" : "./images/list_model3_3.png"} alt="コダック" /></Link>
		        
                <a className="btn_share_count" href={"https://x.com/intent/tweet?url=https://www.morinaga.co.jp/ototo/battlegame/movie/share/" + matchCount + ".html&text=%E3%81%8A%E3%81%A3%E3%81%A8%E3%81%A3%E3%81%A8%E6%81%90%E7%AB%9C%E3%83%90%E3%83%88%E3%83%AB%E5%8B%95%E7%94%BB%E3%82%92%E6%A5%BD%E3%81%97%E3%82%82%E3%81%86%EF%BC%81%EF%BD%9C%E6%A3%AE%E6%B0%B8%E8%A3%BD%E8%8F%93"} target="_blank" rel="noreferrer"><img src="./images/btn_share_count.png" width="100%" alt="X(旧ツイッター)でシェア" /></a>
	          </div>
	        </div>
	        <div className="list_block tab2_model_list pt35 left">
		      <Link id="model2_1" className="model_link" to="/camera" state={{model: "2_1", type: "2"}} onClick={(e) => onLinkClick(e, "model2_1")}><img className="model" src={foundModelList[1][0] ? "./images/list_model2_1_on.png" : "./images/list_model2_1.png"} alt="タッツー" /></Link>
		      <Link id="model2_2" className="model_link" to="/camera" state={{model: "2_2", type: "2"}} onClick={(e) => onLinkClick(e, "model2_2")}><img className="model" src={foundModelList[1][1] ? "./images/list_model2_2_on.png" : "./images/list_model2_2.png"} alt="オクタン" /></Link>
		      <Link id="model3_1_2" className="model_link" to="/camera" state={{model: "3_1", type: "2"}} onClick={(e) => onLinkClick(e, "model3_1")}><img className="model" src={foundModelList[2][0] ? "./images/list_model3_1_on.png" : "./images/list_model3_1_1.png"} alt="デリバード" /></Link>
		      <Link id="model2_3" className="model_link" to="/camera" state={{model: "2_3", type: "2"}} onClick={(e) => onLinkClick(e, "model2_3")}><img className="model" src={foundModelList[1][2] ? "./images/list_model2_3_on.png" : "./images/list_model2_3.png"} alt="ヒノアラシ" /></Link>
		      <Link id="model2_4" className="model_link" to="/camera" state={{model: "2_4", type: "2"}} onClick={(e) => onLinkClick(e, "model2_4")}><img className="model" src={foundModelList[1][3] ? "./images/list_model2_4_on.png" : "./images/list_model2_4.png"} alt="ワニノコ" /></Link>
		      <Link id="model2_5" className="model_link" to="/camera" state={{model: "2_5", type: "2"}} onClick={(e) => onLinkClick(e, "model2_5")}><img className="model" src={foundModelList[1][4] ? "./images/list_model2_5_on.png" : "./images/list_model2_5.png"} alt="カメックス" /></Link>
		      <Link id="model3_2_2" className="model_link" to="/camera" state={{model: "3_2", type: "2"}} onClick={(e) => onLinkClick(e, "model3_2")}><img className="model" src={foundModelList[2][1] ? "./images/list_model3_2_on.png" : "./images/list_model3_2_1.png"} alt="カイリュー" /></Link>
		      <Link id="model3_3_2" className="model_link" to="/camera" state={{model: "3_3", type: "2"}} onClick={(e) => onLinkClick(e, "model3_3")}><img className="model" src={foundModelList[2][2] ? "./images/list_model3_3_on.png" : "./images/list_model3_3_1.png"} alt="ピジョット" /></Link>
		      <Link id="model2_6" className="model_link" to="/camera" state={{model: "2_6", type: "2"}} onClick={(e) => onLinkClick(e, "model2_6")}><img className="model" src={foundModelList[1][5] ? "./images/list_model2_6_on.png" : "./images/list_model2_6.png"} alt="ジュゴン" /></Link>
		        
              <a className="btn_share_count" href={"https://x.com/intent/tweet?url=https://www.morinaga.co.jp/ototo/battlegame/movie/share/" + matchCount + ".html&text=%E3%81%8A%E3%81%A3%E3%81%A8%E3%81%A3%E3%81%A8%E6%81%90%E7%AB%9C%E3%83%90%E3%83%88%E3%83%AB%E5%8B%95%E7%94%BB%E3%82%92%E6%A5%BD%E3%81%97%E3%82%82%E3%81%86%EF%BC%81%EF%BD%9C%E6%A3%AE%E6%B0%B8%E8%A3%BD%E8%8F%93"} target="_blank" rel="noreferrer"><img src="./images/btn_share_count.png" width="100%" alt="X(旧ツイッター)でシェア" /></a>
	        </div>
          </div>
        </div>
        <footer className="content_footer">
          <div className="mb45"><img src="./images/alert/logo.png" width="37.6%" alt="おっとっと" /></div>
          <div><img src="./images/alert/copyright.png" width="86.133%" alt="Copyright © MORINAGA & CO., LTD. All rights reserved." /></div>
        </footer>
        

        {popupId !== "" ? <div id="detail_overlay" className="overlay">
          <div className="overlay_inner no_scale">
            <div className="overlay_movie_block center">
              <div id="overlay_model_image" className="overlay_model_image">
                <iframe src={videoIdList[popupId][videoId]} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style={{position: "absolute", top:0, left:0, width:"100%", height:"100%"}} title="battle1-1"></iframe>
              </div>
              
              <div><a className="close_overlay" href="/#" onClick={(e) => onPopupCloseClick(e)}><img src="./images/btn_popup_close.png" width="63.867%" alt="" /></a></div>
            </div>
          </div>
        </div> : null}
      </div>
    </>
  );
};